import { SerialSearchExpression } from '../../shared/search-expression/serial-search-expression.model';
import { PagedSearch } from '../../shared/model/paged-search.model';
import { RelatedProfileOptionsModel } from './profile-advanced-search-related-profile-options.model';
import { CertificationOptionsModel } from './profile-advanced-search-certifications-options.model';
import { ProfileAdvancedSearchCommitteeOptionsDto } from './dto/profile-advanced-search-committee-options.dto';
import { FormSearchOptionsModel } from './profile-advanced-search-form-search-options.model';
import { BillingCycle } from 'src/app/revenue/shared/billing/billing-cycle.model';

export class ProfileAdvancedSearchParams extends PagedSearch {
  public Keyword: string;
  public AffCodes: string[];
  public MatchAllAffCodes: boolean = false;
  public ExcludeAffCodes: string[];
  public MatchAllExcludeAffCodes: boolean = false;
  // represents an array of expressions to be computed against the db.
  public ContactInfoSearchExpressions: Array<SerialSearchExpression>;
  public CategorySearchExpressions: Array<SerialSearchExpression>;
  public MemberActivitySearchExpressions: Array<SerialSearchExpression>;
  public EventsSearchExpressions: Array<SerialSearchExpression>;
  public FormSearchExpressions: Array<FormSearchOptionsModel>;

  public BillingAnchorMonth: number;
  public BillingRevenueItemNum: number;
  public BillingCycle: string;
  public DuesAmountMin: number;
  public DuesAmountMax: number;
  public UnpaidDuesAfter: Date;
  public UseUnpaidDuesAfter: boolean;
  public IgnoreProfiles: Array<number>;
  public PermitProfiles: Array<number>;
  public RelatedProfileOptions: RelatedProfileOptionsModel;
  public CommonDataView: string;
  public NahbMemberTypes: Array<number>;
  public NahbBusinessActivities: Array<string>;
  public NaaProfileTypes: Array<number>;
  public DataViewId: number;
  public VoterVoicehExpressions: Array<SerialSearchExpression> = [];
  public UseSql: boolean;
  public SqlWhereClause: string;
  public CertificationOptions: Array<CertificationOptionsModel> = [];
  public CommitteeOptions: ProfileAdvancedSearchCommitteeOptionsDto;
  public ArbBillingsOnly: boolean;
  public Guid: string;

  public constructor() {
    super();
    this.Keyword = '';
    this.AffCodes = [];
    this.ExcludeAffCodes = [];
    this.MemberActivitySearchExpressions = new Array<SerialSearchExpression>();
    this.ContactInfoSearchExpressions = new Array<SerialSearchExpression>();
    this.CategorySearchExpressions = new Array<SerialSearchExpression>();
    this.EventsSearchExpressions = new Array<SerialSearchExpression>();
    this.FormSearchExpressions = new Array<FormSearchOptionsModel>();
    this.CertificationOptions = new Array<CertificationOptionsModel>();
    this.OrderBy = 'ASF';
    this.BillingAnchorMonth = 0;
    this.BillingRevenueItemNum = 0;
    this.BillingCycle = '';
    this.DuesAmountMin = 0;
    this.DuesAmountMax = 0;
    this.UnpaidDuesAfter = null;
    this.UseUnpaidDuesAfter = false;
    this.IgnoreProfiles = new Array<number>();
    this.PermitProfiles = new Array<number>();
    this.RelatedProfileOptions = new RelatedProfileOptionsModel();
    this.CommonDataView = '';
    this.NahbMemberTypes = new Array<number>();
    this.NahbBusinessActivities = new Array<string>();
    this.NaaProfileTypes = new Array<number>();
    this.DataViewId = 0;
    this.UseSql = false;
    this.SqlWhereClause = '';
    this.CommitteeOptions = {} as ProfileAdvancedSearchCommitteeOptionsDto;
  }
}
